import { useUser } from "@/redux/user";
import { useMembership } from "@/redux/membership";
import { useLobby } from "@/redux/lobby";
import { useGuestLeagueLimitTracking } from "@/services/useGuestLeagueLimitTracking";

export default function GuestLeagueLimitObserver() {
  const { isGuest } = useUser();
  const { leagueGames } = useMembership();
  const { leaguePlay } = useLobby();
  useGuestLeagueLimitTracking(isGuest, leagueGames, leaguePlay);
  return null;
}
